import React from "react";
import { Box, Container, Stack } from "@mui/material";
import { HeaderToolbar } from "../components/header-toolbar";

interface MainLayoutProps {
  children: React.ReactNode;
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl" | false;
  showNavigation?: boolean;
  /**
   * When true the layout does not scroll; children fill the available height
   * and are expected to manage their own scrolling.
   */
  fixedHeight?: boolean;
}

const MainLayout: React.FC<MainLayoutProps> = ({
  children,
  maxWidth = "xl",
  showNavigation = true,
  fixedHeight = false,
}) => {

  return (
    <Stack
      alignItems="center"
      sx={{
        height: "100vh",
        backgroundColor: "#F5F5F5",
      }}
    >
      {showNavigation && <HeaderToolbar />}
      <Box
        sx={{
          width: "100%",
          flex: 1,
          overflowY: fixedHeight ? "hidden" : "auto",
          display: "flex",
          justifyContent: "center",
          minHeight: 0,
        }}
      >
        <Container
          maxWidth={maxWidth}
          sx={{
            px: 2,
            pb: 2,
            pt: 3,
            ...(fixedHeight && {
              display: "flex",
              flexDirection: "column",
              minHeight: 0,
            }),
          }}
        >
          {children}
        </Container>
      </Box>
    </Stack>
  );
};

export default MainLayout;
